export default __webpack_public_path__ + "static/media/juxtapose.76c7e668.png";